import {format, isValid, parse, parseISO} from 'date-fns';

export function isDateToday ( date ) {
    const now = new Date();
    return now.getDate() === date?.getDate();
}

export function isDateRangeToday ( dateA, dateB ) {
    const now = new Date();
    return dateA?.getDate() === dateB?.getDate() && now.getDate() === dateA?.getDate();
}

export function formatParsedDate ( parsedDate, formatString = 'MM/dd/yyyy' ) {
    if ( isValid( parsedDate ) ) {
        return format( parsedDate, formatString );
    }
    return null;
}

export const DOTNET_DATE_FORMAT = 'MM/dd/yyyy hh:mm:ss a xxx';

export function getFormattedDate ( date, formatString, parseFromString = DOTNET_DATE_FORMAT ) {
    const parsed = parse( date, parseFromString, new Date() );
    return formatParsedDate( parsed, formatString );
}

export function getFormattedISODate ( date, formatString ) {
    const parsed = parseISO( date );
    return formatParsedDate( parsed, formatString );
}
